import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center items-center justify-center px-5 pt-12 pb-10 sm:pt-24 sm:pb-16 overflow-hidden" style={{
    background: 'radial-gradient(ellipse at 50% 30%, #052e16 0%, #0a0a0a 60%)'
  }} data-id="element-153">
      {/* Ambient glow */}
      <div className="absolute top-[20%] left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full pointer-events-none opacity-60" style={{
      background: 'radial-gradient(ellipse, rgba(34,197,94,0.07) 0%, transparent 70%)'
    }} data-id="element-154" />

      {/* Brand */}
      <p className="relative text-[#22C55E]/70 text-sm sm:text-base font-bold tracking-[0.3em] uppercase mb-5 sm:mb-8" data-id="element-155">
        ⚽ EDULABS™
      </p>

      {/* Headline */}
      <h1 className="relative font-black text-white max-w-3xl text-[2.1rem] sm:text-5xl md:text-[4.5rem] leading-[1.08] mb-5 sm:mb-7" data-id="element-156">
        Todo tu año de fútbol formativo{' '}
        <span className="text-[#22C55E]" data-id="element-157">resuelto.</span>
      </h1>

      {/* Tagline pills */}
      <div className="flex flex-col items-center gap-3 sm:gap-4 mb-5 sm:mb-8 max-w-lg" data-id="element-158">
        <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2 sm:gap-x-3" data-id="element-159">
          {['Sesiones', 'Técnica', 'Táctica', 'Evaluación', 'Padres', 'Negocio'].map((item, i) => <span key={i} className="text-[#E7E7E7] text-xs sm:text-sm font-medium bg-white/[0.04] border border-white/[0.06] px-3 sm:px-3.5 py-1.5 sm:py-1.5 rounded-lg" data-id="element-160">
              {item}
            </span>)}
        </div>
        <p className="text-white font-bold text-base sm:text-lg tracking-wide" data-id="element-161">
          ⚡ Listo para usar desde hoy.
        </p>
      </div>

      {/* Product image */}
      <div className="relative w-full max-w-[280px] sm:max-w-[420px] md:max-w-[480px] mx-auto mb-6 sm:mb-8" data-id="element-162">
        <div className="absolute inset-[-16px] rounded-3xl pointer-events-none" style={{
        background: 'radial-gradient(circle, rgba(34,197,94,0.08) 0%, transparent 60%)'
      }} data-id="element-163" />
        <img src="https://cdn.magicpatterns.com/uploads/wGb9q4WdUJqnwvG7ZVqyRL/Diseno_sin_titulo_(21).png" alt="MEGAPACK FÚTBOL LISTO — Combo Completo" className="relative w-full h-auto object-contain" width={1080} height={900} style={{
        aspectRatio: '1080/900'
      }} fetchPriority="high" data-id="element-164" />
      </div>

      {/* Feature bar — visible on desktop only */}
      <div className="hidden sm:flex sm:gap-5 sm:mb-9 text-gray-500 text-xs font-medium tracking-wide uppercase flex-row items-center justify-center flex-wrap" data-id="element-165">
        <span className="text-[#FFFFFF]" data-id="element-166">📄 PDF</span>
        <span className="w-px h-3 bg-gray-700" data-id="element-167" />
        <span className="text-[#FFFFFF]" data-id="element-168">⚡ Inmediato</span>
        <span className="w-px h-3 bg-gray-700" data-id="element-169" />
        <span className="text-[#FFFFFF]" data-id="element-170">🌎 Todo el mundo hispanohablante</span>
        <span className="w-px h-3 bg-gray-700" data-id="element-171" />
        <span className="text-[#FFFFFF]" data-id="element-172">⚽ U4 hasta U16+</span>
      </div>

      {/* CTA */}
      <a href="#pricing" className="btn-green-pulse relative bg-gradient-to-b from-[#2DD264] to-[#1EA94D] text-black font-black text-base sm:text-xl py-4 sm:py-5 rounded-2xl flex items-center justify-center gap-1.5 sm:gap-2 mb-4 sm:mb-4 w-full max-w-xl shadow-[0_0_40px_rgba(34,197,94,0.25),0_4px_20px_rgba(0,0,0,0.3)] hover:shadow-[0_0_60px_rgba(34,197,94,0.45),0_0_120px_rgba(34,197,94,0.15)] hover:scale-[1.03] active:scale-[0.97] transition-all duration-200 overflow-hidden group" data-id="element-173">
        {/* Inner highlight */}
        <span className="absolute inset-0 rounded-2xl border border-white/20 pointer-events-none" data-id="element-174" />
        {/* Top shine */}
        <span className="absolute inset-x-0 top-0 h-[45%] bg-gradient-to-b from-white/15 to-transparent rounded-t-2xl pointer-events-none" data-id="element-175" />
        {/* Hover sweep */}
        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out pointer-events-none" data-id="element-176" />
        <span className="relative z-10 drop-shadow-[0_1px_1px_rgba(0,0,0,0.15)]" data-id="element-177">
          SÍ, QUIERO MI MEGAPACK AHORA
        </span>
        <span className="relative z-10 inline-flex items-center text-base sm:text-xl leading-none animate-[bounceX_1.2s_ease-in-out_infinite]" data-id="element-178">
          →
        </span>
      </a>

      {/* Social proof micro-line */}
      <p className="text-gray-400 text-xs sm:text-sm mb-3 sm:mb-4 font-medium" data-id="element-179">
        ⚡ <span className="text-white font-bold" data-id="element-180">+500 entrenadores</span> ya lo
        tienen
      </p>

      {/* Trust */}
      <p className="text-gray-500 text-xs sm:text-sm tracking-wide leading-relaxed" data-id="element-181">
        🛡️ Garantía 7 días &nbsp;·&nbsp; 🔒 Pago seguro &nbsp;·&nbsp; 💳 Tarjeta
        · PayPal · Transferencia
      </p>
    </section>;
}